import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Process from "./sections/Process";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Services />
      <Process />
      <Footer />
    </div>;
}